"use client";

import { useSuspenseQuery } from "@tanstack/react-query";

import { useMarket } from "#/store/app/portfolio/market";
import { type Market } from "#/types/markets";

import { getInstrumentsQueryOptions } from "../utils/getInstrumentsQueryOptions";

export const useInstruments = (market?: Market) => {
  const { market: currentMarket } = useMarket();

  const effectiveMarket = market || currentMarket;

  const {
    data = [],
    isLoading,
    refetch,
  } = useSuspenseQuery(getInstrumentsQueryOptions(effectiveMarket.underlying));

  return {
    data,
    isLoading,
    refetch,
  };
};
